var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"app-navigation-hint"},[_vm._v("\n\t"+_vm._s(_vm.hint)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }